export default "__VITE_ASSET__BuRz2el7__"